import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { SharedMaterialModule } from "@shared/modules/shared-material.module";
import { ReportAdjustmentsNavigationComponent } from "@app/views/auth/report/components/report-adjustments-sidenav/report-adjustments-navigation/report-adjustments-navigation.component";
import { ReportAdjustmentsPeriodsComponent } from "@app/views/auth/report/components/report-adjustments-periods/report-adjustments-period.component";
import { ReportAdjustmentsComparationComponent } from "@app/views/auth/report/components/report-adjustments-comparation/report-adjustments-comparation.component";
import { ReportAdjustmentsAnalisysplusComponent } from "@app/views/auth/report/components/report-adjustments-analisysplus/report-adjustments-analisysplus.component";
import { ReportAdjustmentsWithoutAnalisysplusComponent } from "@app/views/auth/report/components/report-adjustments-without-analisysplus/report-adjustments-without-analisysplus.component";
import {
    CompanyEntity,
    ScenarioEntity,
    ReportEntity
} from "@arch/domain/entity";
import { DrawerService } from "@app/shared/services/drawer.service";
import {
    EventChangeComparationParams,
    EventChangePeriodParams
} from "../report-toolbar/report-toolbar.component";
import { EventsService } from "@arch/domain/application/services/events.service";
import { ContactService } from "@app/shared/services/contact.service";
@Component({
    selector: "app-report-adjustments-sidenav",
    imports: [
        SharedMaterialModule,
        ReportAdjustmentsNavigationComponent,
        ReportAdjustmentsPeriodsComponent,
        ReportAdjustmentsComparationComponent,
        ReportAdjustmentsAnalisysplusComponent,
        ReportAdjustmentsWithoutAnalisysplusComponent
    ],

    templateUrl: "./report-adjustments-sidenav.component.html",
    styleUrl: "./report-adjustments-sidenav.component.scss"
})
export class ReportAdjustmentsSidenavComponent {
    @Input({ required: false }) optionsNavigation: {
        period?: boolean;
        comparation?: boolean;
        analysisplus?: boolean;
    } = { period: true, comparation: true, analysisplus: true };
    @Input({ required: true }) report: ReportEntity;
    @Input({ required: true }) company: CompanyEntity;
    @Input({ required: true }) scenarios: ScenarioEntity[];
    @Input({ required: false }) currentPage: NavigationItem = null;
    @Input({ required: false }) dropdownConfigs: {
        period?: {
            equalYear: boolean;
        };
        comparation?: {
            equalYear: boolean;
        };
    };

    @Output() onOptionSelected = new EventEmitter<{
        id: string;
        sectionId?: string;
        visualizationId?: string;
    }>();
    @Output() onClose = new EventEmitter<void>();
    @Output() handleChangePeriod = new EventEmitter<EventChangePeriodParams>();
    @Output() handleChangeComparation =
        new EventEmitter<EventChangeComparationParams>();
    @Output() handleResetPeriod = new EventEmitter<void>();
    @Output() handleChangeAnalysis = new EventEmitter<{
        projection: ScenarioEntity;
        budget: ScenarioEntity;
        goals: boolean;
    }>();
    @Output() handleResetAnalysis = new EventEmitter<void>();

    private readonly drawerService = inject(DrawerService);
    private readonly eventsService = inject(EventsService);
    private readonly contactService = inject(ContactService);

    public contact = this.contactService.get();

    constructor() {
        this.drawerService.drawerState$.subscribe((state) => {
            if (!state) {
                this.currentPage = null;
            }
        });
    }

    public onChangePeriod(event: EventChangePeriodParams): void {
        this.handleChangePeriod.emit(event);
        this.eventsService.send(
            `Dash.${this.report.type}.${this.report.humanSourceName}.periodo`
        );
    }

    public onChangeComparation(event: EventChangeComparationParams): void {
        this.handleChangeComparation.emit(event);
        this.eventsService.send(
            `Dash.${this.report.type}.${this.report.humanSourceName}.comparacao`
        );
    }

    public onNavigateChange(navigation: NavigationItem): void {
        this.currentPage = navigation;
    }

    public onBackHome(): void {
        this.onNavigateChange(null);
    }

    public onCloseSidenav(): void {
        this.onClose.emit();
    }

    public handleOptionSelected(event: {
        id: string;
        sectionId?: string;
        visualizationId?: string;
    }): void {
        this.onOptionSelected.emit(event);
    }

    public onApplyAnalysis(event: {
        projection: ScenarioEntity;
        budget: ScenarioEntity;
        goals: boolean;
    }): void {
        this.handleChangeAnalysis.emit(event);
        if (event.projection) {
            this.eventsService.send(
                `Dash.${this.report.type}.${this.report.humanSourceName}.projeção`
            );
        }
        if (event.budget) {
            this.eventsService.send(
                `Dash.${this.report.type}.${this.report.humanSourceName}.orcamento`
            );
        }
        if (event.goals) {
            this.eventsService.send(
                `Dash.${this.report.type}.${this.report.humanSourceName}.objetivo`
            );
        }
    }
}

export type NavigationItem = {
    icon?: string;
    label: string;
    description: string;
    page: number;
};
